import { fg } from '@atlassian/jira-feature-gating';

const isJpdRoadmapsRecentsEnabled = {
	get(): boolean {
		return fg('jpd-enable-roadmaps-recents-fe');
	},
};

export default isJpdRoadmapsRecentsEnabled;
